import Vue from 'vue';
import http from '../../libs/http';
import router from '../../router';
import miniToastr from 'mini-toastr';

import {minitstr_config} from '@/constants';

miniToastr.init(minitstr_config);

export default {
    state: {
        user: false,
        loading: true,
        userError: false,
        usersList: [],
        //roles: [],
        usersPagination: [],
        permissions: [],
        errors:{}
    },
    mutations: {
        SET_USER(state, value) {
            state.user = (value);
        },
        setUsersList(state, value) {
            state.usersList = (value);
        },
        setUsersPagination(state, value) {
            state.usersPagination = (value);
        },
        setUserError(state, values) {
            if (typeof values == 'object') {
                Object.keys(values).forEach(key => {
                    miniToastr.error(Vue.i18n.translate(values[key]), Vue.i18n.translate('messages.error'));
                });
            }
        },
    },
    actions: {
        loginUser({commit, state}, payload = {}) {
            let data = http.route('login').post({...payload}, true);
            data.then(res => {
                if (!res.isError) {
                    sessionStorage.setItem('jwt', res.data.jwt);
                    if (payload.hasOwnProperty('remember') && payload.remember && res.data.hasOwnProperty('rememberToken')) {
                        localStorage.setItem('rememberToken', '');
                    }
                    commit('SET_USER', res.data.user);
                    commit('SET_LANGUAGE', res.data.user.language);
                    this.dispatch('loadUserSelectedRole', res.data.user)
                    this.dispatch('getConstants');

                    router.push({path: "/"});

                    if (typeof res.data.user.fullname != 'undefined') {
                        miniToastr.success(
                            Vue.i18n.translate('messages.welcome') + ' ' + res.data.user.fullname + '! ', 
                            Vue.i18n.translate('messages.success'), 3500
                        );
                    }
                } else {
                    // console.log(res.errorMessage);
                    commit('setUserError', res.errorMessage);
                    commit("routeChange", "end")
                    localStorage.setItem('rememberToken', '');
                }
            });
        },
        logoutUser({commit, state}, payload = {}) {
            const rememberToken = localStorage.getItem('rememberToken');
            let logoutParams = {};

            if (rememberToken) {
                logoutParams = Object.assign({}, {rememberToken});
            }

            let data = http.route('logout').post(logoutParams, true);
            data.then(res => {
                if (!res.isError) {
                    sessionStorage.clear();
                    localStorage.removeItem('rememberToken');
                    commit('SET_PERMISSIONS', []);
                    commit('setUsersList', false);
                    commit('SET_USER_SELECTED_COMPANY', {});
                    commit('SET_USER', false);
                    router.push('/login');

                    miniToastr.success(Vue.i18n.translate('messages.logged_out'), Vue.i18n.translate('messages.success'), 3000);
                } else {
                    if (res.errorCode == 'errors.token') {//force logout
                        commit('forceLogout');
                    } else {
                        //commit('setUserError', res.errorMessage);
                    }
                }
            });
        },
        forceLogout() {
            commit('forceLogout');
            router.push('/login');
        },
        getConstants({commit, state}, payload = {}) {//load the necessary constants to the project from api
            const jwt = sessionStorage.getItem('jwt');
            if (jwt) {
                let data = http.route('constants').get({...payload}, true);
                    data.then(res => {
                        if (!res.isError) {
                            commit('SET_CONSTANTS', res.data);
                            //commit('setUserError', false);
                            //commit('setLoading', false);
                        } else {
                            //commit('setUserError', res.errorMessage);
                        }
                    });
            }
        },

        getUser({commit, state}, payload = {}) {
            let data = http.route('user').get();
            data.then(res => {
                if (!res.isError) {
                    commit('SET_USER', res.data);
                    commit('SET_LANGUAGE', res.data.language);
                    this.dispatch('loadUserSelectedRole', res.data)
                } else {
                    //commit('setUserError', res.errorMessage);
                }
            });
        },
        async editUser({commit, state}, payload = {}) {
            let data = await http.route(`user`).patch({...payload});
            if (!data.isError) {
                // commit('setUser', {});
                this.dispatch('getUser');
                miniToastr.success(Vue.i18n.translate('userprofile.profile') + Vue.i18n.translate('messages.updated'), Vue.i18n.translate('messages.success'), 5000);
                // this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
            } else {
                Object.keys(data.errorMessage).forEach(key => {
                    miniToastr.error(Vue.i18n.translate(data.errorMessage[key]), Vue.i18n.translate('messages.error'), 5000);
                });
                //commit('setUserError', data.errorMessage);
            }
            return data;
        },
        async editPassword({commit, state}, payload = {}) {
            let data = await http.route(`user/changepassword/${payload.id}`).patch({...payload});
            if (!data.isError) {
                //commit('setUserError', false);
                miniToastr.success(Vue.i18n.translate('userprofile.password') + Vue.i18n.translate('messages.updated'), Vue.i18n.translate('messages.success'));
            } else {
                //commit('setUserError', data.errorMessage);
            }
            return data;
        },
        loadUserSelectedRole({commit, state}, payload = {}) {
            if (Object.keys(payload.roles).length > 0) {
                try {
                    let selected_role = payload.data.selected_role_id;
                    if (typeof payload.roles[selected_role] != 'undefined') {
                        commit('SET_USER_SELECTED_COMPANY', payload.roles[selected_role]);
                    }
                } catch(e) {
                }

                switch (Object.keys(payload.roles).length) {
                    case 1:
                        commit('SET_USER_SELECTED_COMPANY', payload.roles[Object.keys(payload.roles)[0]]);
                        break;
                }
            }
        },
        async saveUserSelectedRole({commit, state}, payload = {}) {
            let role_id = 0;
            if (payload) {
                role_id = payload.role_id;
            }
            let data = await http.route('user').patch({...{
                                                            'update_role'  : true,
                                                            'selected_role_id': role_id,
                                                            }});
            if (data.isError) {

            }
            return data;
        },
        getAllUsers({commit, state}, payload = {}) {
            let data = http.route('users').get({...payload});
            data.then(res => {
                if (!res.isError) {
                    commit('setUsersList', res.data);
                    commit('setUsersPagination', res.pagination);
                } else {
                    // commit('setUserError', res.errorMessage);
                }
                return res;
            });
        },
        getRolesUsers({commit, state}, payload = {}) {
            let data = http.route('roles/users').get();
            data.then(res => {
                if (!res.isError) {
                    commit('setRolesUsers', res.data);
                } else {
                    // commit('setUserError', res.errorMessage);
                }
                return res;
            });
        },

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js